import { IconProps } from '../icons';
import { themeColors } from '@styles/theme';

export const LockOpenedIcon = ({
    width = 36,
    height = 36,
    color = themeColors.grey,
}: IconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.5 10V7.5
       C16.5 5.6 15 4.5 13.5 4.5
       C11.6 4.5 10.5 5.9 10.5 7.5"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect
                x="6"
                y="10"
                width="12"
                height="10"
                rx="2"
                stroke={color}
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path d="M12 14.5V16.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    );
};
